import { useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { InputTextarea } from 'primereact/inputtextarea'

interface CancelInformModalProps {
  visible: boolean
  onHide: () => void
  onConfirm: (reason: string) => void
  loading?: boolean
}

export default function CancelInformModal({ visible, onHide, onConfirm, loading }: CancelInformModalProps) {
  const [reason, setReason] = useState('')

  function handleConfirm() {
    onConfirm(reason)
    setReason('')
  }

  function handleHide() {
    setReason('')
    onHide()
  }

  const header = (
    <span style={{ color: '#B27668', fontWeight: 600, fontSize: '1.25rem' }}>
      Cancelar informe
    </span>
  )

  const footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '0.75rem' }}>
      <Button
        label='Cancelar pedido'
        onClick={handleConfirm}
        loading={loading}
        style={{
          background: '#3CB8BA',
          borderColor: '#3CB8BA',
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '1rem',
          borderRadius: '6px',
          padding: '0.6rem 1.4rem',
        }}
      />
    </div>
  )

  return (
    <Dialog
      visible={visible}
      onHide={handleHide}
      header={header}
      footer={footer}
      style={{ width: '480px', borderRadius: '12px', overflow: 'hidden' }}
      closable
      closeIcon='pi pi-times'
      pt={{
        closeButton: {
          style: { color: '#3CB8BA' },
        },
        footer: {
          style: { background: '#f5f5f5', borderTop: '1px solid #e5e7eb', padding: '1rem 1.5rem 1.5rem' },
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <InputTextarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder='Explicar motivos (opcional):'
          rows={4}
          style={{
            width: '100%',
            resize: 'none',
            border: '1px solid #c2cbd6',
            borderRadius: '4px',
          }}
        />
        <p style={{ margin: 0, color: '#374151', fontSize: '0.95rem' }}>
          Al cancelar el informe se cambiará la solicitud a la lista de cancelados.
        </p>
      </div>
    </Dialog>
  )
}
